import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Necesito tener conocimientos de finanzas para aplicar este método?',
  a: 'No. Reinicia Tus Finanzas fue diseñado para emprendedores, comerciantes y dueños de negocios que buscan resultados prácticos. Todo está explicado paso a paso con ejemplos simples y fáciles de implementar.'
}, {
  q: '¿Este método sirve para cualquier tipo de negocio?',
  a: 'Sí, los principios de organización financiera aplican tanto si vendés productos físicos, ofrecés servicios, tenés un local a la calle o un negocio 100% digital.'
}, {
  q: '¿En cuánto tiempo puedo empezar a ver resultados?',
  a: 'Si aplicás la Fase 1 y 2 (Diagnosticar y Organizar), vas a tener claridad total sobre tus números en la primera semana. Los resultados de crecimiento dependen de tu implementación constante.'
}, {
  q: '¿Qué formato tiene el producto?',
  a: 'Es un programa 100% digital. Al realizar el pago, recibís acceso inmediato a nuestra plataforma donde encontrarás todos los materiales, planillas y bonus listos para descargar y usar.'
}, {
  q: '¿Qué incluye exactamente la versión de $19.990?',
  a: 'Incluye el Método de 6 Fases completo y los 6 Bonus de regalo estándar. Es ideal si querés empezar a ordenar tus números sin herramientas avanzadas de planificación a largo plazo.'
}, {
  q: '¿Qué incluye exactamente el KIT PRO de $24.990?',
  a: 'Incluye TODO lo del plan completo, más los 3 Bonus Plus Premium (Calendario 12 meses, Planificador de Objetivos y el Sistema $100K Extra). Es la opción más elegida para un control total.'
}, {
  q: '¿Cuál es la diferencia entre ambos planes?',
  a: 'La diferencia principal son los 3 Bonus Plus Premium del KIT PRO, que te dan herramientas avanzadas para planificar a largo plazo y generar ingresos extra, por solo $5.000 de diferencia.'
}, {
  q: '¿Cuándo recibo el producto?',
  a: 'El acceso es inmediato. Una vez confirmado el pago, te llega un mail automático con tus datos de acceso a la plataforma para que empieces hoy mismo.'
}, {
  q: '¿Este método me ayudará a ganar más dinero?',
  a: 'Sí. Al detectar fugas de dinero (Fase 1) y aplicar las estrategias de multiplicación (Fase 3), vas a optimizar tus recursos y aumentar tu ganancia neta real.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-background" data-id="element-56">
      <div className="container mx-auto px-6" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-58">
          <h2 className="text-4xl md:text-5xl mb-6" data-id="element-59">
            PREGUNTAS <span className="text-primary italic" data-id="element-60">FRECUENTES</span>
          </h2>
        </motion.div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-61">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="bg-surface border border-surface-light rounded-2xl overflow-hidden" data-id="element-62">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-surface-light/50 transition-colors" data-id="element-63">
                  <span className="font-medium text-lg pr-8" data-id="element-64">{faq.q}</span>
                  <ChevronDownIcon className={`w-5 h-5 text-primary flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-65" />
                </button>
                <AnimatePresence data-id="element-66">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-67">
                      <div className="px-6 pb-5 pt-2 text-text-muted leading-relaxed border-t border-surface-light/50" data-id="element-68">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}